export function getLocationLatitude(location) {
  return location?.latitude ?? location?.lat ?? null;
}

export function getLocationLongitude(location) {
  return location?.longitude ?? location?.long ?? null;
}

export function formatDecimalCoord(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) {
    return '';
  }
  return num.toFixed(2);
}

/** Latitude: 42.33,  Longitude: -83.05 */
export function formatLatLonLine(lat, lon) {
  if (lat == null && lon == null) {
    return '';
  }
  const parts = [];
  if (lat != null) {
    parts.push(`Latitude: ${formatDecimalCoord(lat)}`);
  }
  if (lon != null) {
    parts.push(`Longitude: ${formatDecimalCoord(lon)}`);
  }
  return parts.join(',  ');
}

export function formatTimezoneUtcOffset(timezone) {
  if (!timezone) {
    return null;
  }
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'longOffset',
    }).formatToParts(new Date());
    const offsetPart = parts.find((part) => part.type === 'timeZoneName');
    return offsetPart?.value?.replace('GMT', 'UTC') ?? null;
  } catch {
    return null;
  }
}

/** TZ: America/Detroit,  UTC-05:00 */
export function formatTimezoneLine(timezone, utcOffset) {
  if (!timezone && !utcOffset) {
    return '';
  }
  const offset = utcOffset || (timezone ? formatTimezoneUtcOffset(timezone) : '');
  if (timezone && offset) {
    return `TZ: ${timezone},  ${offset}`;
  }
  if (timezone) {
    return `TZ: ${timezone}`;
  }
  return offset;
}

export function formatLocationCoordinates(location) {
  return formatLatLonLine(
    getLocationLatitude(location),
    getLocationLongitude(location),
  );
}

export function formatLocationTimezone(location) {
  return formatTimezoneLine(
    location?.timezone,
    location?.utc_offset,
  );
}

export function formatBirthCoordinatesLine(birthData) {
  if (!birthData) {
    return '';
  }
  return formatLatLonLine(birthData.lat, birthData.long);
}

export function formatBirthTimezoneLine(birthData) {
  if (!birthData) {
    return '';
  }
  return formatTimezoneLine(birthData.timezone, birthData.utc_offset);
}
